import { defineComponent } from 'vue';
import { QIcon, QMenu } from 'quasar';

/**
 * Compact readonly field that opens a popup menu for scope header dropdowns.
 */
export default defineComponent({
    name: 'ControlDesignerScopeSummaryField',
    components: {
        QIcon,
        QMenu,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        displayText: {
            type: String,
            default: '',
        },
        popupOpen: {
            type: Boolean,
            default: false,
        },
        popupMaxWidth: {
            type: String,
            default: '860px',
        },
        disableCloseOnApply: {
            type: Boolean,
            default: false,
        },
        popupFit: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:popupOpen', 'before-close'],
    methods: {
        setPopupOpen(value) {
            if (!value && this.disableCloseOnApply)
                return;
            this.$emit('update:popupOpen', value);
        },
        togglePopup(event) {
            event?.stopPropagation?.();
            this.setPopupOpen(!this.popupOpen);
        },
        onBeforeHide(evt) {
            this.$emit('before-close');
            if (this.disableCloseOnApply && evt?.preventDefault)
                evt.preventDefault();
        },
    },
    render() {
        const display = this.displayText || '';

        return (
            <div
                class="control-designer-scope-summary-field"
                style={{ flex: 1, minWidth: 0 }}
            >
                <div
                    class="control-designer-scope-summary-field__trigger"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '22px',
                        padding: '0 6px',
                        border: '1px solid #9e9e9e',
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        gap: '4px',
                        minWidth: 0,
                        boxSizing: 'border-box',
                    }}
                    onClick={(event) => this.togglePopup(event)}
                >
                    <span
                        style={{
                            flexShrink: 0,
                            fontSize: '11px',
                            fontWeight: 600,
                            lineHeight: 1,
                            color: '#374151',
                        }}
                    >
                        {this.label}
                    </span>
                    <span
                        style={{
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            fontSize: '11px',
                            lineHeight: 1,
                            color: display ? '#111827' : '#9ca3af',
                        }}
                    >
                        {display}
                    </span>
                    <QIcon
                        name="mdi-menu-down"
                        size="14px"
                        style={{ flexShrink: 0, color: '#6b7280' }}
                    />
                    <QMenu
                        modelValue={this.popupOpen}
                        onUpdate:modelValue={(value) => this.setPopupOpen(value)}
                        noParentEvent
                        anchor="bottom left"
                        self="top left"
                        fit={this.popupFit}
                        maxHeight="80vh"
                        style={this.popupFit ? undefined : { maxWidth: this.popupMaxWidth, width: this.popupMaxWidth }}
                        onBeforeHide={(evt) => this.onBeforeHide(evt)}
                    >
                        {this.$slots.default?.()}
                    </QMenu>
                </div>
            </div>
        );
    },
});
